import { SOGetDeficiency } from '../deficiency/so-get-deficiency';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPutWork {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public active: boolean = null,
    public deficiency: SOGetDeficiency = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutWork(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'active' in params ? params.active : null,
      'deficiency' in params ? params.deficiency : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
